/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable prefer-spread */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { useEffect, useState, useCallback } from 'react';
import { Pagination, CnCheckbox, CnRadio } from '@alife/cn-ui';
import classNames from 'classnames';
import { Code, State, Image, Name } from './render';
import './index.scss';
function getAttr(attrs, obj) {
    return attrs
        ?.filter?.((attr) => attr && typeof attr === 'string')
        ?.reduce?.((tempObj, attr) => tempObj?.[attr], obj);
}
function transformRender(columns, renders) {
    columns.forEach((col) => {
        const { key } = col;
        if (renders[key]) {
            col.render = renders[key];
        }
    });
}
function getDomProps(props, rest) {
    let ret = props;
    if (props instanceof Function) {
        ret = props.apply(null, rest);
    }
    return ret;
}
export const renderMap = new Map();
export default function OPTable(props) {
    const { dataSource: tableInitData = [], columns = [], className, renders, rowProps, cellProps, primaryKey, selectedKeys, hasHeader = true, onRowClick = () => { }, onPageChange = () => { }, pagination = {
        enabled: false,
        pageSize: 10,
        currentPage: 1,
        onPageSizeChange: () => { },
        onCurrentPageChange: () => { },
    }, showSelect = false, // 开启选择行
    rowSelection = {
        type: 'multiple',
    }, onSelectChange = () => { }, // 选择行后的回调
    autoWidth = true, // 设置自动宽度后，表格列 设的宽度失效
     } = props;
    const [currentPage, setCurrentPage] = useState(pagination.currentPage || 1);
    const [pageSize, setPageSize] = useState(pagination.pageSize || 10);
    const [indeterminate, setIndeterminate] = useState(false);
    const [headerChecked, setHeaderChecked] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowRecord, setSelectedRowRecord] = useState([]);
    const [dataSource, setDataSource] = useState(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    JSON.parse(JSON.stringify(tableInitData)));
    renders && transformRender(columns, renders);
    useEffect(() => {
        setDataSource(tableInitData);
    }, [tableInitData]);
    // 分页条数改变
    const onPageSizeChange = React.useCallback((v) => {
        setPageSize(v);
        setCurrentPage(1);
        pagination.onPageSizeChange && pagination.onPageSizeChange(v);
        onPageChange &&
            onPageChange({
                currentPage: 1,
                pageSize: v,
            });
    }, [pagination, onPageChange]);
    // 翻页改变
    const onCurrentPageChange = React.useCallback((v) => {
        setCurrentPage(v);
        pagination.onCurrentPageChange && pagination.onCurrentPageChange(v);
        onPageChange &&
            onPageChange({
                currentPage: v,
                pageSize,
            });
    }, [pagination, onPageChange, pageSize]);
    const handleRowSelectionChangeMultiple = useCallback((keys) => {
        const records = [];
        const tmpDataSource = dataSource;
        // 过滤传入的 keys 不存在于 dataSource 中
        keys = keys.filter((k) => !!dataSource.filter((item, index) => k === (primaryKey ? item[primaryKey] : index)).length);
        if (keys && Array.isArray(keys)) {
            tmpDataSource.forEach((recordItem, recordIndex) => {
                if (
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                keys.includes(primaryKey ? recordItem[primaryKey] : recordIndex)) {
                    records.push(recordItem);
                    recordItem.checked = true;
                    recordItem.selected = true;
                }
                else {
                    recordItem.checked = false;
                    recordItem.selected = false;
                }
            });
            setHeaderChecked(keys.length === tmpDataSource.length);
            setIndeterminate(!!(keys.length && keys.length !== tmpDataSource.length));
            setSelectedRowKeys(keys);
            setSelectedRowRecord(records);
            setDataSource(tmpDataSource);
            onSelectChange && onSelectChange(keys, records);
        }
    }, [dataSource, onSelectChange, primaryKey]);
    // 行选中状态改变-多选
    const onCheckedChangeFromTd = useCallback((checked, record, index) => {
        let keys = selectedRowKeys;
        const checkedKey = (primaryKey ? record[primaryKey] : index);
        if (checked) {
            keys.push(checkedKey);
        }
        else {
            keys = keys.filter((k) => k !== checkedKey);
        }
        handleRowSelectionChangeMultiple(keys);
    }, [handleRowSelectionChangeMultiple, primaryKey, selectedRowKeys]);
    const handleRowSelectionChangeSingle = useCallback((checkedKey, checked) => {
        const tmpDataSource = dataSource;
        let record = {};
        tmpDataSource.forEach((recordItem, recordIndex) => {
            if (checkedKey === (primaryKey ? recordItem[primaryKey] : recordIndex)) {
                recordItem.checked = checked;
                recordItem.selected = true;
                record = recordItem;
            }
            else {
                recordItem.checked = false;
                recordItem.selected = false;
            }
        });
        setSelectedRowKeys(checkedKey);
        setSelectedRowRecord(record);
        setDataSource(tmpDataSource);
        onSelectChange && onSelectChange(checkedKey, record);
    }, [dataSource, onSelectChange, primaryKey]);
    // 行选中状态改变-单选
    const onCheckedChangeFromTdSingle = useCallback((checked, record, index) => {
        const checkedKey = (primaryKey ? record[primaryKey] : index);
        handleRowSelectionChangeSingle(checkedKey, checked);
    }, [handleRowSelectionChangeSingle, primaryKey]);
    useEffect(() => {
        // 初始默认选中行
        if (showSelect && rowSelection.selectedRowKeys) {
            rowSelection.type === 'single'
                ? handleRowSelectionChangeSingle(rowSelection.selectedRowKeys, !!rowSelection.selectedRowKeys)
                : handleRowSelectionChangeMultiple(rowSelection.selectedRowKeys);
        }
    }, [
        handleRowSelectionChangeMultiple,
        handleRowSelectionChangeSingle,
        rowSelection.selectedRowKeys,
        rowSelection.type,
        showSelect,
    ]);
    // 表头选中状态改变
    const onCheckedChangeFromTh = useCallback((checked) => {
        setHeaderChecked(checked);
        setIndeterminate(false);
        if (checked) {
            handleRowSelectionChangeMultiple(dataSource.map((item, index) => (primaryKey ? item[primaryKey] : index)));
        }
        if (!checked) {
            handleRowSelectionChangeMultiple([]);
        }
    }, [dataSource, handleRowSelectionChangeMultiple, primaryKey]);
    return (React.createElement("div", { className: `op-table-wrapper` },
        React.createElement("table", { role: 'table', className: classNames('op-table', className, {
                'auto-width': autoWidth,
            }) },
            React.createElement("colgroup", null,
                showSelect && React.createElement("col", { style: { minWidth: 50 } }),
                columns.map((item) => (React.createElement("col", { style: { width: item.width }, key: item.key })))),
            hasHeader && (React.createElement("thead", { className: 'op-table-header' },
                React.createElement("tr", null,
                    showSelect && (React.createElement("th", { className: 'lock-select' }, rowSelection.type === 'single' ? null : (React.createElement(CnCheckbox, { indeterminate: indeterminate, checked: headerChecked, onChange: onCheckedChangeFromTh })))),
                    columns.map((item) => {
                        return (React.createElement("th", { key: item.key, className: classNames(`${getAlignTdClassName(item.align)} th_${item.key}`, item?.lock ? `lock-${item.lock}` : '', {
                                'lock-left-has-select': showSelect,
                            }) }, item.title || item.name));
                    })))),
            React.createElement("tbody", { className: 'next-table-body' }, dataSource.map((item, index) => {
                const currentKey = primaryKey
                    ? item[primaryKey]
                    : index;
                return (React.createElement("tr", { ...getDomProps(rowProps || {}, [index, item]), className: getRowClassName(item, props), role: 'row', key: currentKey, onClick: () => {
                        if (showSelect && rowSelection.type === 'single') {
                            handleRowSelectionChangeSingle(currentKey, true);
                        }
                        if (showSelect && rowSelection.type !== 'single') {
                            let newKeys = [];
                            if (item.checked) {
                                if (Array.isArray(selectedRowKeys)) {
                                    newKeys = selectedRowKeys.filter((k) => currentKey !== k);
                                }
                            }
                            else {
                                if (Array.isArray(selectedRowKeys)) {
                                    newKeys = selectedRowKeys.concat([currentKey]);
                                }
                            }
                            handleRowSelectionChangeMultiple(newKeys);
                        }
                        onRowClick(item, index);
                    } },
                    showSelect && (React.createElement("td", { className: 'lock-select operate-table-cell__first' }, rowSelection.type === 'single' ? (React.createElement(CnRadio, { checked: item.checked, onChange: (checked) => {
                            onCheckedChangeFromTdSingle(checked, item, index);
                        } })) : (React.createElement(CnCheckbox, { checked: item.checked, onChange: (checked) => {
                            onCheckedChangeFromTd(checked, item, index);
                        } })))),
                    columns.map((column, colIndex) => {
                        return (React.createElement("td", { ...getDomProps(cellProps || {}, [
                                item[column.key],
                                index,
                                colIndex,
                                item,
                            ]), key: column.key, className: classNames(getAlignTdClassName(column.align), getTdSerialClassName(colIndex, columns.length - 1, showSelect), column?.lock ? `lock-${column.lock}` : '', {
                                'lock-left-has-select': showSelect,
                            }) }, renderTD(item, column, index)));
                    })));
            }))),
        pagination && pagination?.enabled && (React.createElement("div", { className: 'op-pagination-con' },
            React.createElement(Pagination, { size: 'large', type: 'simple', pageSizeSelector: 'dropdown', ...pagination, current: currentPage, pageSize: pageSize, onPageSizeChange: onPageSizeChange, onChange: onCurrentPageChange })))));
}
function getRowClassName(data, props) {
    const { primaryKey, selectedKeys, completeKeys } = props;
    const keyValue = data[primaryKey];
    return classNames({
        selected: data.selected || Array.from(selectedKeys ?? '').includes(keyValue),
        complete: data.complete ||
            data.completed ||
            Array.from(completeKeys ?? '').includes(keyValue),
    });
}
function getAlignTdClassName(align) {
    return ({
        right: 'td-align-right',
        left: 'td-align-left',
        center: 'td-align-center',
    }[align] || 'td-align-left');
}
function getTdSerialClassName(index, total, showSelect) {
    return classNames('operate-table-cell', {
        'operate-table-cell__first': !showSelect && index === 0,
        'operate-table-cell__last': index === total,
    });
}
// 2023.2.27 render优化
function renderTD(record, column, index) {
    const { key, render, options } = column;
    const value = getAttr([...(key?.split?.('.') || [])], record);
    const renderProps = { value, index, record, options };
    if (render instanceof Function) {
        // 自定义render
        return render(value, index, record, options);
    }
    if (typeof render === 'string') {
        // 内置render
        const renderName = render.toLowerCase();
        switch (renderName) {
            case 'code':
                return React.createElement(Code, { ...renderProps });
            case 'pkstatus':
                return React.createElement(State, { ...renderProps });
            case 'image':
                return React.createElement(Image, { ...renderProps });
            case 'name':
                return React.createElement(Name, { ...renderProps });
            default:
                return value;
        }
    }
    return value;
}
